const KNOWLEDGE_BASE = {
  MAIN_TITLE: 'Knowledge Base',
  SUB_TITLE: 'In this section, you can customize your knowledge base.',
  COLOR_TITLE: 'Choose the main color of your knowledge base.',
  KNOWLEDGE_BASE_TITLE: 'Knowledge Base Title',
  KNOWLEDGE_BASE_TITLE_PLACEHOLDER: 'Your Knowledge Base',
  DESCRIPTION: 'Description',
  DESCRIPTION_PLACEHOLDER: 'Enter the description',
  DOMAIN_NAME: 'Domain Name',
  DOMAIN_NAME_PLACEHOLDER: 'Enter your domain name',
  WEBSITE_LINK: 'Website Address',
  WEBSITE_LINK_PLACEHOLDER: 'Enter your website address',
  SCRIPT_TITLE: 'HTML and Script Codes',
  CUSTOMIZATION_TITLE: 'Text Customization',
  PAGE_TITLE: 'Page Header Title',
  PAGE_TITLE_PLACEHOLDER: 'Enter the page header title',
  SEARCH_TEXT: 'Search Text',
  SEARCH_PLACEHOLDER: 'Enter search text',
  BUTTON: 'Save',
  ERROR_MESSAGE: 'Filling out all fields is mandatory!',
  COLOR_ERROR_MESSAGE: 'Selecting a base knowledge color is essential!',
  LOGO_ERROR_MESSAGE: 'Choosing a base knowledge logo is essential!',
  TITLE_ERROR_MESSAGE: 'Writing a base knowledge title is essential!',
  DESC_ERROR_MESSAGE: 'Writing base knowledge descriptions is essential!',
  DOMAIN_ERROR_MESSAGE: 'Writing a base knowledge domain name is essential!',
  LINK_ERROR_MESSAGE:
    'Adding a base knowledge link (along with https://) is essential!',
  UN_VALID_LINK: 'Enter your knowledge base link correctly!',
  PAGE_TITLE_ERROR_MESSAGE: 'Writing a base knowledge page title is essential!',
  SEARCH_TEXT_ERROR_MESSAGE:
    'Writing search text for base knowledge is essential!',

  SUCCESSFUL_MESSAGE: 'Data saved successfully!',
  KNOWLEDGE_BASE_LOGO: 'Knowledge-Base Logo',
  KNOWLEDGE_BASE_LOGO_PLACEHOLDER: 'Upload image',
  KNOWLEDGE_BASE_DOWNLOAD_BTN: 'Download Installation File',
  PHOTO_UPLOAD_RECOMMENDATION:
    'The recommended dimensions for the logo are 55x55 pixels, and it should be in PNG format.',
  YOUR_KNOWLEDGE_BASE_LINK: 'Your knowledge base link',
};

export default KNOWLEDGE_BASE;
